import { render, staticRenderFns } from "./bsp-tabs.vue?vue&type=template&id=0b177236&scoped=true&"
import script from "./bsp-tabs.vue?vue&type=script&lang=js&"
export * from "./bsp-tabs.vue?vue&type=script&lang=js&"
import style0 from "./bsp-tabs.vue?vue&type=style&index=0&id=0b177236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b177236",
  null
  
)

export default component.exports